import React from 'react';
import BuseaAppWrapper from './components/containers/BuseaAppWrapper';

function App() {
  return <BuseaAppWrapper />;
}

export default App;
